import { AspectRatio } from '../../services/api/songAdService';

export const SONG_AD_FPS = 30;

/** 比率ごとのComposition解像度（VideoAdsPage.tsx の getDimensions() と同じ値を使う） */
export function getSongAdDimensions(aspectRatio: AspectRatio): { width: number; height: number } {
  switch (aspectRatio) {
    case '16:9':
      return { width: 1920, height: 1080 };
    case '1:1':
      return { width: 1080, height: 1080 };
    case '9:16':
    default:
      return { width: 1080, height: 1920 };
  }
}

/**
 * target_seconds（30/45/60。v6 F7で15秒は廃止したが、既存プロジェクトの実測値が
 * そのまま渡ってくる可能性があるため引数自体は number のまま）→ durationInFrames（30fps）
 */
export function getSongAdDurationInFrames(targetSeconds: number): number {
  return Math.max(1, Math.round(targetSeconds * SONG_AD_FPS));
}
